/**
 * Add/Edit Payer form — Zod contract for AddPayerModal in settings/payers.
 */
import { z } from 'zod';
import { US_STATE_CODES } from '@/pages/onboarding/constants';

export const payerSchema = z.object({
  name: z.string().trim().min(1, 'Name is required'),
  active: z.boolean(),
  state: z
    .string()
    .trim()
    .transform((value) => value.toUpperCase())
    .refine((value) => value === '' || (US_STATE_CODES as readonly string[]).includes(value), {
      message: 'Select a valid US state',
    })
    .optional(),
  soharId: z.string().trim().optional(),
  stediNetworkId: z.string().trim().optional(),
  verifiableMedicaidId: z.string().trim().optional(),
  verifiableMedicareId: z.string().trim().optional(),
  verifiableCommercialId: z.string().trim().optional(),
});

export type PayerFormInput = z.infer<typeof payerSchema>;

export const defaultPayerFormValues: PayerFormInput = {
  name: '',
  active: true,
  state: '',
  soharId: '',
  stediNetworkId: '',
  verifiableMedicaidId: '',
  verifiableMedicareId: '',
  verifiableCommercialId: '',
};
